import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const OurPets = () => {
  return (
    <div data-testid="our-pets-page">
      {/* Hero Section */}
      <section className="py-16 lg:py-24 bg-[#1A1C18]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
              Find Your New Best Friend
            </span>
            <h1 className="font-['Bebas_Neue'] text-6xl lg:text-8xl text-white mb-6">
              Our Pets
            </h1>
            <p className="text-xl text-[#A3A3A3] max-w-2xl mx-auto">
              All of our cats and dogs are spayed/neutered, vaccinated, and microchipped. Meet your future family member.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Adoption Fees */}
      <section className="py-8 border-y border-[#4A5320]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 text-center">
            <div>
              <span className="font-['Bebas_Neue'] text-3xl text-[#FFD700]">$400</span>
              <span className="block text-[#A3A3A3] text-sm font-mono">Dogs (over 1 year)</span>
            </div>
            <div>
              <span className="font-['Bebas_Neue'] text-3xl text-[#FFD700]">$500</span>
              <span className="block text-[#A3A3A3] text-sm font-mono">Puppies (under 1 year)</span>
            </div>
            <div>
              <span className="font-['Bebas_Neue'] text-3xl text-[#FFD700]">$500+</span>
              <span className="block text-[#A3A3A3] text-sm font-mono">Board & Train Dogs</span>
            </div>
            <div>
              <span className="font-['Bebas_Neue'] text-3xl text-[#FFD700]">$100</span>
              <span className="block text-[#A3A3A3] text-sm font-mono">Cats (over 1 year)</span>
            </div>
            <div>
              <span className="font-['Bebas_Neue'] text-3xl text-[#FFD700]">$150</span>
              <span className="block text-[#A3A3A3] text-sm font-mono">Kittens (under 1 year)</span>
            </div>
          </div>
        </div>
      </section>

      {/* Pets Iframe Section */}
      <section className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#1A1C18] border border-[#4A5320] rounded-lg overflow-hidden">
            <iframe
              src="https://rescuesupportkit.com/rescue/rescue_default_teb"
              title="Three Eye Blind Animal Rescue - Adoptable Pets"
              className="w-full border-0 h-[800px] lg:h-[2500px]"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1A1C18] border-t border-[#4A5320]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
            Ready to Save a Life?
          </span>
          <h2 className="font-['Bebas_Neue'] text-5xl text-white mb-6">
            Start Your Application
          </h2>
          <p className="text-[#A3A3A3] text-lg mb-8 max-w-2xl mx-auto">
            Whether you want to adopt, foster, or foster-to-adopt, we&apos;d love to hear from you. Our team will guide you through every step.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://rescuesupportkit.com/rescue/3eyeblind/applications"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="apply-adopt-button"
              className="btn-primary inline-flex items-center gap-2"
            >
              Apply Now
              <ExternalLink className="w-4 h-4" />
            </a>
            <Link to="/foster-resources" className="btn-secondary">
              Foster Resources
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurPets;
